import type { Settings } from "../types";

const STORAGE_KEY = "trippin.settings.v1";
const LEGACY_KEYS = ["show_points", "show_camps", "show_joy", "show_towers", "show_lines", "realm"];

export const DEFAULT_SETTINGS: Settings = {
  showStats: false,
  showPoints: false,
  showCamps: true,
  showJoyScore: true,
  showTowers: false,
  showLines: false,
  showCellCoverage: true,
};

export function loadSettings(storage: Storage = window.localStorage): Settings {
  try {
    const stored = storage.getItem(STORAGE_KEY);
    if (!stored) return { ...DEFAULT_SETTINGS };
    const parsed: unknown = JSON.parse(stored);
    if (!parsed || typeof parsed !== "object") return { ...DEFAULT_SETTINGS };
    const values = parsed as Partial<Record<keyof Settings, unknown>>;
    return {
      showStats: typeof values.showStats === "boolean" ? values.showStats : DEFAULT_SETTINGS.showStats,
      showPoints: typeof values.showPoints === "boolean" ? values.showPoints : DEFAULT_SETTINGS.showPoints,
      showCamps: typeof values.showCamps === "boolean" ? values.showCamps : DEFAULT_SETTINGS.showCamps,
      showJoyScore:
        typeof values.showJoyScore === "boolean" ? values.showJoyScore : DEFAULT_SETTINGS.showJoyScore,
      showTowers: typeof values.showTowers === "boolean" ? values.showTowers : DEFAULT_SETTINGS.showTowers,
      showLines: typeof values.showLines === "boolean" ? values.showLines : DEFAULT_SETTINGS.showLines,
      showCellCoverage:
        typeof values.showCellCoverage === "boolean"
          ? values.showCellCoverage
          : DEFAULT_SETTINGS.showCellCoverage,
    };
  } catch {
    return { ...DEFAULT_SETTINGS };
  }
}

export function saveSettings(settings: Settings, storage: Storage = window.localStorage): void {
  try {
    storage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch {
    // Storage can be unavailable in privacy modes; settings are best effort.
  }
}

export function clearLegacySettings(storage: Storage = window.localStorage): void {
  try {
    for (const key of LEGACY_KEYS) storage.removeItem(key);
  } catch {
    // Legacy cleanup is best effort for restricted storage implementations.
  }
}
